import { SimpleGrid } from '@chakra-ui/react';
import RestaurantCard from '~/components/RestaurantCard';

import { useNavigate, useParams } from 'react-router-dom';

import mediaQueryStateAtom from '~/recoil/atom/mediaQueryState';
import { useRecoilValue } from 'recoil';

import { AlgoliaStore } from '~/types/store/store';
import getScheduleTimeString from '~/utils/getScheduleTimeString';
import RestaurantItem from '~/components/RestaurantItem';

import parseISO from 'date-fns/parseISO';

type PopularRestaurantProps = {
  storeList: Array<AlgoliaStore>;
  pickMealTime: Date | null;
};

export default function PopularRestaurant({ storeList, pickMealTime }: PopularRestaurantProps) {
  const { isLargerThan768 } = useRecoilValue(mediaQueryStateAtom);
  const navigate = useNavigate();
  const { groupId = '' } = useParams();

  return (
    <SimpleGrid columns={isLargerThan768 ? 1 : 2} align="stretch" py={2} spacing={1}>
      {storeList.map((store) =>
        isLargerThan768 ? (
          <RestaurantCard
            key={store.objectID}
            name={store.name}
            address={store.address}
            image={store.image}
            logo={store.logo}
            time={getScheduleTimeString(
              store.preOrderSetting.schedule,
              store.officialHolidayISOString?.map((isoString) => parseISO(isoString)) || [],
              pickMealTime,
            )}
            onNavigate={() =>
              navigate(
                groupId ? `/group/${groupId}/store/${store.objectID}` : `/store/${store.objectID}`,
                { state: { previous: window.location.pathname } },
              )
            }
          />
        ) : (
          <RestaurantItem
            key={store.objectID}
            name={store.name}
            address={store.address}
            image={store.image}
            logo={store.logo}
            time={getScheduleTimeString(
              store.preOrderSetting.schedule,
              store.officialHolidayISOString?.map((isoString) => parseISO(isoString)) || [],
              pickMealTime,
            )}
            onNavigate={() =>
              navigate(
                groupId ? `/group/${groupId}/store/${store.objectID}` : `/store/${store.objectID}`,
                { state: { previous: window.location.pathname } },
              )
            }
          />
        ),
      )}
    </SimpleGrid>
  );
}
